<template>
  <el-tabs v-model="activeName">
    <el-tab-pane label="预约概况" name="first">
      <div v-if="Lib.checkPower('beauty-4-ckyygk',2)">
        <el-row>
          <el-date-picker v-model="time" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :clearable="false" @change="onChangeTime"></el-date-picker>
        </el-row>
        <el-row type="flex" class="achivement_data" justify="space-around">
          <div>
            <span>{{ bookSituation.bookTotle }}</span>
            <span>预约总数</span>
          </div>
          <div>
            <span>{{ bookSituation.bookServeTotle }}</span>
            <span>预约项目数</span>
          </div>
          <div>
            <span>{{ bookSituation.bookTechnicianTotle }}</span>
            <span>预约{{ Lib.collectively() }}数</span>
          </div>
          <div>
            <span>{{ bookSituation.bookRoomTotle }}</span>
            <span>房间预订数</span>
          </div>
        </el-row>
        <br />
        <div style="position:relative;">
          <el-tabs v-model="activeName2" type="card">
            <el-tab-pane label="预约明细" name="first">
              <el-table ref="yymxTable" v-loading="loading" tooltip-effect="light" :data="pageData" style="width: 100%" @sort-change="yymxSortChange">
                <el-table-column align="left" prop="dateTime" label="日期" sortable></el-table-column>
                <el-table-column align="left" prop="bookServe" label="预约项目次数" sortable></el-table-column>

                <el-table-column align="left" prop="bookTechnician" :label="'预约'+Lib.collectively()+'次数'" sortable></el-table-column>
                <el-table-column align="left" prop="bookRoom" label="房间预订次数" sortable></el-table-column>
                <el-table-column align="left" prop="totle" label="预约合计数" sortable></el-table-column>

                <el-table-column align="left" prop="bookFinish" label="预约完成数" sortable></el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="预约来源" name="second">
              <el-table ref="yylyTable" v-loading="loading" tooltip-effect="light" :data="pageData" style="width: 100%" @sort-change="yylySortChange">
                <el-table-column align="left" prop="dateTime" label="日期" sortable></el-table-column>
                <el-table-column align="left" prop="pcstation" label="电脑端预约数" sortable></el-table-column>

                <el-table-column align="left" prop="appstation" label="店员App预约数" sortable></el-table-column>
                <el-table-column align="left" prop="smallStation" label="粉丝端预约数" sortable></el-table-column>
                <!-- <el-table-column align="left" prop="starAPPstation" label="样子App预约数"></el-table-column>
                            <el-table-column align="left" prop="starSmallStation" label="样子小程序预约数"></el-table-column> -->
                <el-table-column align="left" prop="totle" label="合计预约数" sortable></el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
          <div class="button_group">
            <el-button type="primary" size="small" @click="onDownload">导出报表</el-button>
            <el-button type="primary" size="small" @click="onPrint">打印报表</el-button>
          </div>
        </div>
        <el-pagination background layout="prev, pager, next" :total="pageTotal" :current-page.sync="currentPage" @current-change="pageDataFn"></el-pagination>
      </div>
      <gt-noneData v-else :title="'暂无权限，请联系管理员分配权限'" :is-no-permission="true"></gt-noneData>
    </el-tab-pane>
    <el-tab-pane label="项目预约分析" name="second">
      <div v-if="Lib.checkPower('beauty-4-ckxmyyfx2',2)">
        <customerTable ref="xmyyTable" :data="pageData" :array="table_col" :time-range2="time_range2" :is-show-config="true" :is-hide-search="false" :loading="loading" @timeChange="timeChange" @onCheckDetail="onCheckDetail" @ondownload="onDownload" @onPrint="onPrint" @sortChange="sortChange" />
        <el-pagination background layout="prev, pager, next" :total="pageTotal" :current-page.sync="currentPage" @current-change="pageDataFn"></el-pagination>
      </div>
      <gt-noneData v-else :title="'暂无权限，请联系管理员分配权限'" :is-no-permission="true"></gt-noneData>
    </el-tab-pane>
    <el-tab-pane :label="Lib.collectively()+'预约分析'" name="third">
      <div v-if="Lib.checkPower('beauty-4-ckjsyybb',2)">
        <customerTable ref="jsyyTable" :data="pageData" :array="table_col" :time-range3="time_range3" :is-show-config="true" :is-hide-search="false" :loading="loading" @timeChange="timeChange" @onCheckDetail="onCheckDetailFw" @ondownload="onDownload" @onPrint="onPrint" @sortChange="sortChangeFw" />
        <el-pagination background layout="prev, pager, next" :total="pageTotal" :current-page.sync="currentPage" @current-change="pageDataFn"></el-pagination>
      </div>
      <gt-noneData v-else :title="'暂无权限，请联系管理员分配权限'" :is-no-permission="true"></gt-noneData>
    </el-tab-pane>
    <el-tab-pane :label="getRoomType==1?'房间预订分析':getRoomType==2?'床位预订分析':'台位预订分析'" name="fourth">
      <div v-if="Lib.checkPower('beauty-4-ckfjfwtwyybb',2)">
        <customerTable ref="fjydTable" :data="pageData" :array="table_col" :time-range4="time_range4" :is-hide-search="false" :is-show-config="true" :loading="loading" @ondownload="onDownload" @timeChange="timeChange" @onPrint="onPrint" @onCheckDetail="onCheckDetailHome" @sortChange="sortChangeHome" />
        <el-pagination background layout="prev, pager, next" :total="pageTotal" :current-page.sync="currentPage" @current-change="pageDataFn"></el-pagination>
      </div>
      <gt-noneData v-else :title="'暂无权限，请联系管理员分配权限'" :is-no-permission="true"></gt-noneData>
    </el-tab-pane>
    <el-tab-pane v-if="Lib.checkPower('beauty-3-yyjsfx',2)" :label="'预约'+Lib.collectively()+'分析'" name="fifth">
      <div v-if="Lib.checkPower('beauty-4-ckyyjsbb',2)">
        <customerTable ref="yyjsTable" :data="pageData" :array="table_col" :time-range5="time_range5" :is-show-config="true" :is-hide-search="false" :loading="loading" @timeChange="timeChange" @onCheckDetail="onCheckDetailJs" @ondownload="onDownload" @onPrint="onPrint" @sortChange="sortChangeJs" />
        <el-pagination background layout="prev, pager, next" :total="pageTotal" :current-page.sync="currentPage" @current-change="pageDataFn"></el-pagination>
      </div>
      <gt-noneData v-else :title="'暂无权限，请联系管理员分配权限'" :is-no-permission="true"></gt-noneData>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import dayjs from 'dayjs';
import api from './api/index';
import customerTable from './template/others/customer_table';

export default {
  components: {
    customerTable
  },
  data() {
    return {
      activeName: 'first',
      activeName2: 'first',
      time: [
        dayjs()
          .subtract(30, 'day')
          .format('YYYY-MM-DD'),
        dayjs().format('YYYY-MM-DD')
      ],
      tableData: [],
      headerData: {},
      pageTotal: 0,
      pageData: [],
      // expireTimeOption: {
      //   disabledDate(date) {
      //     return date.getTime() > Date.now();
      //   }
      // },
      bookSituation: {},
      currentPage: 1,
      table_col: [],
      time_range2: [
        dayjs()
          .subtract(30, 'day')
          .format('YYYY-MM-DD'),
        dayjs().format('YYYY-MM-DD')
      ],
      time_range3: [
        dayjs()
          .subtract(30, 'day')
          .format('YYYY-MM-DD'),
        dayjs().format('YYYY-MM-DD')
      ],
      time_range4: [
        dayjs()
          .subtract(30, 'day')
          .format('YYYY-MM-DD'),
        dayjs().format('YYYY-MM-DD')
      ],
      time_range5: [
        dayjs()
          .subtract(30, 'day')
          .format('YYYY-MM-DD'),
        dayjs().format('YYYY-MM-DD')
      ],
      // 5.7
      loading: true,
      getRoomType: window.sessionStorage.tidyStatus, // 设置的房态  1房间  2床位  3台位(5.10)

      // 6.7
      newSort: '',
      newSortBy: 1,
    };
  },
  computed: {},
  watch: {
    activeName2(val) {
      this.currentPage = 1;
      if (val === 'first') {
        this.getBookDetails();
      } else {
        this.getBookSource();
      }
    },
    activeName(val) {
      this.currentPage = 1;
      if (val === 'first') {
        if (this.activeName2 === 'first') {
          this.getBookDetails();
        } else {
          this.getBookSource();
        }
        return;
      }
      if (val === 'second') {
        this.getBookServe();
      }
      if (val === 'third') {
        this.getBookTechnician();
      }
      if (val === 'fourth') {
        this.getBookRoom();
      }
      if (val === 'fifth') {
        this.getTechnicianBook();
      }
    }
  },
  activated() {
    this.getRoomType = window.sessionStorage.tidyStatus;// 设置的房态  1房间  2床位  3台位
    this.currentPage = 1;
    if (this.activeName === 'first') {
      this.getBookSituation();
      if (this.activeName2 === 'first') {
        this.getBookDetails();
      } else {
        this.getBookSource();
      }
    }
    if (this.activeName === 'second') {
      this.getBookServe();
    }
    if (this.activeName === 'third') {
      this.getBookTechnician();
    }
    if (this.activeName === 'fourth') {
      this.getBookRoom();
    }
    if (this.activeName === 'fifth') {
      this.getTechnicianBook();
    }
  },
  methods: {
    // 6.7预约明细排序
    yymxSortChange({ prop, order }) {
      this.getBookDetails(prop, order);
    },
    // 6.7预约来源排序
    yylySortChange({ prop, order }) {
      this.getBookSource(prop, order);
    },
    onChangeTime() {
      this.getBookSituation();
      if (this.activeName2 === 'first') {
        this.getBookDetails();
      } else {
        this.getBookSource();
      }
    },
    // 获取预约概况
    getBookSituation() {
      const data = {
        beginTime: this.time[0],
        endTime: this.time[1],
        mainId: sessionStorage.getItem('mainId')
      };
      api.getBookSituation(data).then((res) => {
        this.bookSituation = res.data;
      });
    },
    // 获取预约明细
    getBookDetails(prop, order) {
      this.loading = true;
      if (!prop) {
        this.$refs.yymxTable.clearSort();
      } else {
        this.newSort = prop ? (`${prop}`) : 'dateTime';
        this.newSortBy = order == 'descending' ? 1 : 2;
      }
      const data = {
        beginTime: this.time[0],
        endTime: this.time[1],
        mainId: sessionStorage.getItem('mainId'),
        pageNum: 1,
        sort: prop ? (`${prop}`) : 'dateTime',
        sortBy: order == 'descending' ? 1 : 2
      };

      api.getBookDetails(data).then((res) => {
        this.pageTotal = res.data.length;
        this.tableData = res.data;
        this.loading = false;
        this.pageDataFn(1);
      });
    },
    // 获取预约来源
    getBookSource(prop, order) {
      this.loading = true;
      if (!prop) {
        this.$refs.yylyTable.clearSort();
      } else {
        this.newSort = prop ? (`${prop}`) : 'dateTime';
        this.newSortBy = order == 'descending' ? 1 : 2;
      }
      const data = {
        beginTime: this.time[0],
        endTime: this.time[1],
        mainId: sessionStorage.getItem('mainId'),
        sort: prop ? (`${prop}`) : 'dateTime',
        sortBy: order == 'descending' ? 1 : 2
      };
      api.getBookSource(data).then((res) => {
        this.pageTotal = res.data.length;
        this.tableData = res.data;
        this.loading = false;
        this.pageDataFn(1);
      });
    },
    // 获取 预约项目
    getBookServe(prop, order) {
      this.loading = true;
      if (!prop) {
        this.$refs.xmyyTable.clearSort();
      } else {
        this.newSort = prop ? (`${prop}`) : 'dateTime';
        this.newSortBy = order == 'descending' ? 1 : 2;
      }
      const data = {
        beginTime: this.time_range2[0],
        endTime: this.time_range2[1],
        mainId: sessionStorage.getItem('mainId'),
        sort: prop ? (`${prop}`) : 'dateTime',
        sortBy: order == 'descending' ? 1 : 2
      };
      this.table_col = [
        {
          name: '预约日期',
          prop: 'dateTime',
          showTip: false,
          tip: ''
        },
        {
          name: '当日预约项目次数',
          prop: 'bookServeNum',
          showTip: false,
          tip: ''
        },
        {
          name: '当日用户取消次数',
          prop: 'memberRemoveNum',
          showTip: false,
          tip: ''
        },
        {
          name: '当日商家取消次数',
          prop: 'shopRemoveNum',
          showTip: false,
          tip: ''
        },
        {
          name: '当日过期次数',
          prop: 'expireNum',
          showTip: false,
          tip: ''
        },
        {
          name: '当日订单完成次数',
          prop: 'serveFinishNum',
          showTip: false,
          tip: ''
        }
      ];
      api.getBookServe(data).then((res) => {
        this.pageTotal = res.data.length;
        this.tableData = res.data;
        this.loading = false;
        this.pageDataFn(1);
      });
    },
    // 获取 预约统称
    getBookTechnician(prop, order) {
      this.loading = true;
      if (!prop) {
        this.$refs.jsyyTable.clearSort();
      } else {
        this.newSort = prop ? (`${prop}`) : 'dateTime';
        this.newSortBy = order == 'descending' ? 1 : 2;
      }
      const data = {
        beginTime: this.time_range3[0],
        endTime: this.time_range3[1],
        mainId: sessionStorage.getItem('mainId'),
        sort: prop ? (`${prop}`) : 'dateTime',
        sortBy: order == 'descending' ? 1 : 2
      };
      this.table_col = [
        {
          name: '预约日期',
          prop: 'dateTime',
          showTip: false,
          tip: ''
        },
        {
          name: `当日预约${this.Lib.collectively()}次数`,
          prop: 'bookTechnicianNum',
          showTip: false,
          tip: ''
        },
        {
          name: '当日用户取消次数',
          prop: 'memberRemoveNum',
          showTip: false,
          tip: ''
        },
        {
          name: '当日商家取消次数',
          prop: 'shopRemoveNum',
          showTip: false,
          tip: ''
        },
        {
          name: '当日过期次数',
          prop: 'expireNum',
          showTip: false,
          tip: ''
        },
        {
          name: '当日订单完成次数',
          prop: 'serveFinishNum',
          showTip: false,
          tip: ''
        }
      ];
      api.getBookTechnician(data).then((res) => {
        this.pageTotal = res.data.length;
        this.tableData = res.data;
        this.loading = false;
        this.pageDataFn(1);
      });
    },
    // 获取 房间预订
    getBookRoom(prop, order) {
      this.loading = true;
      if (!prop) {
        this.$refs.fjydTable.clearSort();
      } else {
        this.newSort = prop ? (`${prop}`) : 'dateTime';
        this.newSortBy = order == 'descending' ? 1 : 2;
      }
      const data = {
        beginTime: this.time_range4[0],
        endTime: this.time_range4[1],
        mainId: sessionStorage.getItem('mainId'),
        sort: prop ? (`${prop}`) : 'dateTime',
        sortBy: order == 'descending' ? 1 : 2
      };
      // 判断是房间还是 titleStatus: window.sessionStorage.tidyStatus, // 设置的房态  1房间  2床位  3台位
      this.table_col = [
        {
          name: '预约日期',
          prop: 'dateTime',
          showTip: false,
          tip: ''
        },
        {
          name: '当日预订次数',
          prop: 'bookNum',
          showTip: false,
          tip: ''
        },
        {
          name: '当日取消预订次数',
          prop: 'bookRemoveNum',
          showTip: false,
          tip: ''
        },
        {
          name: '当日使用数',
          prop: 'checkInNum',
          showTip: false,
          tip: ''
        }
      ];
      if (this.getRoomType == 1) {
        api.getBookRoom(data).then((res) => {
          this.pageTotal = res.data.length;
          this.tableData = res.data;
          this.loading = false;
          this.pageDataFn(1);
        });
      } else {
        api.getBookRoomBed(data).then((res) => {
          this.pageTotal = res.data.length;
          this.tableData = res.data;
          this.loading = false;
          this.pageDataFn(1);
        });
      }
    },
    // 获取 预约技师分析
    getTechnicianBook(prop, order) {
      this.loading = true;
      if (!prop) {
        this.$refs.yyjsTable.clearSort();
      } else {
        this.newSort = prop ? (`${prop}`) : 'bookCount';
        this.newSortBy = order == 'descending' ? 1 : 2;
      }
      const data = {
        beginTime: this.time_range5[0],
        endTime: this.time_range5[1],
        mainId: sessionStorage.getItem('mainId'),
        sort: prop ? (`${prop}`) : 'bookCount',
        sortBy: order == 'descending' ? 1 : 2
      };
      this.table_col = [
        {
          name: '员工名称',
          prop: 'technicianName',
          showTip: false,
          tip: ''
        },
        {
          name: '预约次数',
          prop: 'bookCount',
          showTip: false,
          tip: ''
        },
        {
          name: '用户取消次数',
          prop: 'clientCancelCount',
          showTip: false,
          tip: ''
        },
        {
          name: '商家取消次数',
          prop: 'busCancelCount',
          showTip: false,
          tip: ''
        },
        {
          name: '过期次数',
          prop: 'expiredCount',
          showTip: false,
          tip: ''
        },
        {
          name: '完成次数',
          prop: 'completeCount',
          showTip: false,
          tip: ''
        }
      ];
      api.getTechnicianBook(data).then((res) => {
        this.pageTotal = res.data.length;
        this.tableData = res.data;
        this.loading = false;
        this.pageDataFn(1);
      });
    },
    // 分页数据处理函数
    pageDataFn(number) {
      // 处于第几页 number
      // 保存每页数据的函数
      const pagedata = [];
      // pagesize=10 每页条数
      // 设置开始
      const start = 10 * number - 10;
      // 设置结束长度
      let end = 10 * number; // 长度判断 //所有分页数据 this.tableData
      end = end > this.tableData.length ? this.tableData.length : end;
      for (let i = start; i < end; i++) {
        // 所有分页数据 this.tableData
        pagedata.push(this.tableData[i]);
      }
      this.currentPage = number;
      this.pageData = pagedata;
    },
    timeChange(val) {
      if (this.activeName === 'second') {
        this.time_range2 = val;
        this.getBookServe();
      }
      if (this.activeName === 'third') {
        this.time_range3 = val;
        this.getBookTechnician();
      }
      if (this.activeName === 'fourth') {
        this.time_range4 = val;
        this.getBookRoom();
      }
      if (this.activeName === 'fifth') {
        this.time_range5 = val;
        this.getTechnicianBook();
      }
    },
    onCheckDetail(scope) {
      if (this.Lib.checkPower('beauty-5-ckxmyybbxq') == false) return;
      this.$router.push({
        name: 'bookAnalyse-index',
        params: {
          newTitle: '项目预约分析详情',
          word: '项目预约分析详情',
          date: scope.row.dateTime
        }
      });
    },
    onCheckDetailFw(scope) {
      if (this.Lib.checkPower('beauty-5-ckjsyybbxq') == false) return;
      this.$router.push({
        name: 'bookAnalyse-index',
        params: {
          newTitle: `${this.Lib.collectively()}预约分析详情`,
          word: `${this.Lib.collectively()}预约分析详情`,
          date: scope.row.dateTime
        }
      });
    },
    onCheckDetailHome(scope) {
      if (this.Lib.checkPower('beauty-5-ckfjfwtwyybbxq') == false) return;
      this.$router.push({
        name: 'bookAnalyse-index',
        params: {
          newTitle: `${this.Lib.returnRoomOrBed()}预订分析详情`,
          word: `${this.Lib.returnRoomOrBed()}预订分析详情`,
          date: scope.row.dateTime
        }
      });
    },
    onCheckDetailJs(scope) {
      if (this.Lib.checkPower('beauty-5-ckyyjsbbxq') == false) return;
      this.$router.push({
        name: 'bookAnalyse-index',
        params: {
          newTitle: `预约${this.Lib.collectively()}分析详情`,
          word: `预约${this.Lib.collectively()}分析详情`,
          date: this.time_range5,
          technicianId: scope.row.technicianId
        }
      });
    },
    sortChange({ prop, order }) {
      this.getBookServe(prop, order);
    },
    sortChangeFw({ prop, order }) {
      this.getBookTechnician(prop, order);
    },
    sortChangeHome({ prop, order }) {
      this.getBookRoom(prop, order);
    },
    sortChangeJs({ prop, order }) {
      this.getTechnicianBook(prop, order);
    },
    onDownload() {
      if (this.activeName === 'first') {
        if (this.Lib.checkPower('beauty-4-dcyygkbb') == false) return;
        if (this.activeName2 === 'first') {
          this.$root.$children[0].fatherExport('exportBookDetails', this.time[0], this.time[1], this.newSort, this.newSortBy);
        } else {
          this.$root.$children[0].fatherExport('exportBookSource', this.time[0], this.time[1], this.newSort, this.newSortBy);
        }
      }
      if (this.activeName === 'second') {
        if (this.Lib.checkPower('beauty-4-dcxmyyfx2') == false) return;
        this.$root.$children[0].fatherExport('exportBookServe', this.time_range2[0], this.time_range2[1], this.newSort, this.newSortBy);
      }
      if (this.activeName === 'third') {
        if (this.Lib.checkPower('beauty-4-dcjsyybb') == false) return;
        this.$root.$children[0].fatherExport('exportBookTechnician', this.time_range3[0], this.time_range3[1], this.newSort, this.newSortBy);
      }
      if (this.activeName === 'fourth') {
        if (this.Lib.checkPower('beauty-4-dcfjfwtwyybb') == false) return;
        if (this.getRoomType == 1) {
          this.$root.$children[0].fatherExport('exportBookRoom', this.time_range4[0], this.time_range4[1], this.newSort, this.newSortBy);
        } else {
          // 5.10新增
          this.$root.$children[0].fatherExport('exportBookRoomBed', this.time_range4[0], this.time_range4[1], this.newSort, this.newSortBy);
        }
      }
      if (this.activeName === 'fifth') {
        if (this.Lib.checkPower('beauty-4-dcyyjsbb') == false) return;
        this.$root.$children[0].fatherExport('exportTechnicianBook', this.time_range5[0], this.time_range5[1], this.newSort, this.newSortBy);
      }
    },
    onPrint() {
      if (this.activeName === 'first') {
        if (this.Lib.checkPower('beauty-4-dyyygkbb') == false) return;
        if (this.activeName2 === 'first') {
          this.$print({
            data: this.tableData,
            table_tol: [
              {
                name: '日期',
                prop: 'dateTime'
              },
              {
                name: '预约项目次数',
                prop: 'bookServe'
              },
              {
                name: `预约${this.Lib.collectively()}次数`,
                prop: 'bookTechnician'
              },
              {
                name: '房间预订次数',
                prop: 'bookRoom'
              },
              {
                name: '预约合计数',
                prop: 'totle'
              },
              {
                name: '预约完成数',
                prop: 'bookFinish'
              }
            ],
            title: '预约明细'
          });
        } else {
          this.$print({
            data: this.tableData,
            table_tol: [
              {
                name: '日期',
                prop: 'dateTime'
              },
              {
                name: '电脑端预约数',
                prop: 'pcstation'
              },
              {
                name: '店员App预约数',
                prop: 'appstation'
              },
              {
                name: '粉丝端预约数',
                prop: 'smallStation'
              },
              // {
              //   name: '样子App预约数',
              //   prop: 'starAPPstation'
              // },
              // {
              //   name: '样子小程序预约数',
              //   prop: 'starSmallStation'
              // },
              {
                name: '合计预约数',
                prop: 'totle'
              }
            ],
            title: '预约来源'
          });
        }
      }
      if (this.activeName === 'second') {
        if (this.Lib.checkPower('beauty-4-dyxmyyfx2') == false) return;
        this.$print({
          data: this.tableData,
          table_tol: this.table_col,
          title: '项目预约分析'
        });
      }
      if (this.activeName === 'third') {
        if (this.Lib.checkPower('beauty-4-dyjsyybb') == false) return;
        this.$print({
          data: this.tableData,
          table_tol: this.table_col,
          title: `${this.Lib.collectively()}预约分析`
        });
      }
      if (this.activeName === 'fourth') {
        if (this.Lib.checkPower('beauty-4-dyfjfwtwyybb') == false) return;
        this.$print({
          data: this.tableData,
          table_tol: this.table_col,
          title: `${this.Lib.returnRoomOrBed()}预订分析`
        });
      }
      if (this.activeName === 'fifth') {
        if (this.Lib.checkPower('beauty-4-dyyyjsbb') == false) return;
        this.$print({
          data: this.tableData,
          table_tol: this.table_col,
          title: `预约${this.Lib.collectively()}分析`
        });
      }
    }
  }
};
</script>
<style scoped>
.achivement_data {
  border: 1px solid rgba(230, 235, 245, 1);
  margin-top: 20px;
  padding: 20px 0;
}
.achivement_data > div {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: center;
}
.achivement_data > div:nth-child(1) {
  border-right: 1px solid #e6ebf5;
  padding-right: 166px;
}
.achivement_data > div > span:nth-child(1) {
  font-size: 36px;
  color: #fd5c8c;
}
.achivement_data > div > span:nth-child(2) {
  font-size: 16px;
  color: #333333;
}
.button_group {
  position: absolute;
  right: 0;
  top: 0;
}
</style>
